"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntlTranslationsProvider = exports.TranslationsProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var getNumericSymbols = function (intl) {
    return [
        "visualization.numericValues.k",
        "visualization.numericValues.m",
        "visualization.numericValues.g",
        "visualization.numericValues.t",
        "visualization.numericValues.p",
        "visualization.numericValues.e",
    ].map(function (id) { return intl.formatMessage({ id: id }); });
};
/**
 * @internal
 */
var TranslationsProvider = /** @class */ (function (_super) {
    tslib_1.__extends(TranslationsProvider, _super);
    function TranslationsProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TranslationsProvider.prototype.render = function () {
        var props = {
            numericSymbols: getNumericSymbols(this.props.intl),
            emptyHeaderString: this.getEmptyHeaderString(),
            intl: this.props.intl,
        };
        return this.props.children(props);
    };
    TranslationsProvider.prototype.getEmptyHeaderString = function () {
        var emptyValueTranslation = this.props.intl.formatMessage({ id: "visualization.emptyValue" });
        return "(" + emptyValueTranslation + ")";
    };
    return TranslationsProvider;
}(react_1.default.PureComponent));
exports.TranslationsProvider = TranslationsProvider;
/**
 * @internal
 */
exports.IntlTranslationsProvider = react_intl_1.injectIntl(TranslationsProvider);
//# sourceMappingURL=TranslationsProvider.js.map